// extracted by mini-css-extract-plugin
export var footerInfo = "footerInfo-module--footerInfo--3_QOH";
export var inner = "footerInfo-module--inner--3MOQy";
export var general = "footerInfo-module--general--qYuQ9";
export var partners = "footerInfo-module--partners--c97uH";
export var owners = "footerInfo-module--owners--1OxUI";